// extracted by mini-css-extract-plugin
export var root = "BT3W";
export var rootClose = "-dPo";
export var rootOverlay = "-KJ1";
export var rootPlayer = "Xl6G";
export var rootVideo = "LcQs";